'use client';

import React, { useEffect, useRef } from 'react';
import './HorizontalScrollImages.scss';

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Image, RichText } from '@sitecore-jss/sitecore-jss-react';

gsap.registerPlugin(ScrollTrigger);

const data = [
  {
    id: 1,
    text: 'Panoramic sunroof',
    image: {
      id: 456,
      url: 'https://strapi-upload-images-prod.s3.eu-west-2.amazonaws.com/Panoramic_sunroof_9cf4eae126.webp',
    },
  },
  {
    id: 2,
    text: 'Comfortable chairs',
    image: {
      id: 460,
      url: 'https://strapi-upload-images-prod.s3.eu-west-2.amazonaws.com/Comfortable_chairs_9eb8ffa6f2.webp',
    },
  },
];

export default function HorizontalScrollImages({ items }) {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const ctx = gsap.context(() => {
      const sections = gsap.utils.toArray('.panel');

      gsap.to(sections, {
        xPercent: -100 * (sections.length - 1),
        ease: 'none',
        scrollTrigger: {
          trigger: container,
          pin: true,
          scrub: 1,
          snap: 1 / (sections.length - 1),
          end: () => `+=${container.offsetWidth}`,
        },
      });
    }, container);

    return () => ctx.revert();
  }, []);

  return (
    <div className={'car-model-design-block-image'}>
      <div
        ref={containerRef}
        className={'panelContainer panel-container'}
        style={{ width: `calc(888px * ${items.length})` }}
      >
        {items.map((item) => (
          <section key={item.id} className={'imagePanel panel'}>
            <div className={'item'}>
              <Image
                field={item.fields.image}
                alt={item.text}
                width={888}
                height={640}
                style={{ objectFit: 'cover', borderRadius: '20px' }}
              />
              <div className={'item_text'}>
                <div>
                  <RichText field={item.fields.titleRichText} />
                </div>
                <p className={'item_desc'}>{item.fields.text.value}</p>
              </div>
            </div>
          </section>
        ))}
      </div>
      <div className={'container'}>
        {items.map((item) => (
          <section key={item.id} className={'imageLaptop'}>
            <div className={'itemLaptop'}>
              <Image
                field={item.fields.styleImageMobile}
                alt={item.text}
                width={802}
                height={400}
                style={{
                  objectFit: 'cover',
                  borderRadius: '20px',
                  width: '100%',
                }}
              />
              <div className={'itemLaptop_text'}>
                {/* <div>{item.fields.title.value}</div> */}
                <div>
                  <RichText field={item.fields.titleRichText} />
                </div>
                <p className={'item_desc'}>{item.fields.text.value}</p>
              </div>
              {/* <p className={'itemLaptop_text'}>{item.fields.title.value}</p> */}
              {/* <p className={'itemLaptop_text'}>{item.fields.text.value}</p> */}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
